import { createSlice } from '@reduxjs/toolkit';

export const streamInfoSlice = createSlice({
  name: 'streamInfo',
  initialState: {
    eventID: null,
    createdBy: null,
    defaultBoxName: '',
    globalName: '',
    boxName: '',
    boxDetails: [],
    defaultSeatBox: {},
    globalChatSid: '',
    userEmail: '',
    userId: null,
    participantName: '',
    eventLayoutId: '',
    eventLayoutUrl: '',
  },
  reducers: {
    updateAll: (state, action) => {
      const {
        globalRoomName,
        boxRoomName,
        defaultBoxName,
        eventID,
        createdBy,
        defaultSeatBox,
        globalChatSid,
        userEmail,
        userId,
        participantName,
        eventLayoutId,
        eventLayoutUrl,
      } = action.payload;
      return {
        ...state,
        globalName: globalRoomName,
        boxName: boxRoomName,
        defaultBoxName: defaultBoxName,
        eventID: eventID,
        createdBy: createdBy,
        defaultSeatBox: defaultSeatBox,
        globalChatSid: globalChatSid,
        userEmail: userEmail,
        userId: userId,
        participantName: participantName,
        eventLayoutId: eventLayoutId,
        eventLayoutUrl: eventLayoutUrl,
      };
    },
    updateBoxName: (state, action) => {
      const { boxRoomName } = action.payload;
      return { ...state, boxName: boxRoomName };
    },
    updateOnlyBoxes: (state, action) => {
      const { boxDetails } = action.payload;
      return { ...state, boxDetails: boxDetails };
    },
    clearAll: () => {
      return {
        globalName: '',
        boxName: '',
        boxDetails: [],
        defaultBoxName: '',
        eventID: null,
      };
    },
  },
});

export const { updateAll, updateBoxName, updateOnlyBoxes, clearAll } =
  streamInfoSlice.actions;

export default streamInfoSlice.reducer;
